// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__73A3O","tyre":"style_tyre__-ddhC"};